import {createAction} from 'web-app/util/redux/famly-app-helpers';

import type Models from './models';

const domain = 'LISTS';

export const {
    action: fetchLists,
    success: fetchListsSuccess,
    failed: fetchListsFailed,
} = createAction(
    `${domain}_FETCH_LISTS`,
    (institutionId: string) => ({
        institutionId,
    }),
    (lists: ReturnType<typeof Models.fromAPI>) => ({lists}),
);

export const {
    action: deleteList,
    success: deleteListSuccess,
    failed: deleteListFailed,
} = createAction(
    `${domain}_DELETE_LIST`,
    (listId: string) => ({
        listId,
    }),
    (listId: string) => ({listId}),
);
